import { render, staticRenderFns } from "./ModForm.vue?vue&type=template&id=2723ca93&"
import script from "./ModForm.vue?vue&type=script&lang=js&"
export * from "./ModForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports